"use strict";

exports.__esModule = true;
exports.default = void 0;

var _formSelect = require("./form-select");

var _plugins = require("../../utils/plugins");

var components = {
  BFormSelect: _formSelect.default,
  BSelect: _formSelect.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/form-select/index.js
// module id = 457
// module chunks = 0